<template>
  <div class="w-full">
    <div class="max-w-3xl mx-auto py-5">
      <alert
        level="warning"
        :message="$store.state.app.i18n.errors[404]"
        class="px-5"
      ></alert>
    </div>
  </div>
</template>

<script>
export default {
  props: [],
  components: {},
  mixins: [],
  data: function () {
    return {};
  },
  methods: {},
  computed: {},
  mounted() {},
};
</script>
